export default __webpack_public_path__ + "static/media/about.de1912e0.jpg";